module.exports = __webpack_public_path__ + "85daf3e26718db9ecd1f2d831fbf4cbb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-sky.png
// module id = 3649
// module chunks = 0